<script>
import ParticleUtils from '@/utils/particlesUtils'
import EventsUtils from '@/utils/eventsUtils'

export default
{
    name: 'loading-bar',

    props:
    {
        progress: { type: Number, default: 0.0 },
        particles: { type: Boolean, default: false },
        text: { type: String }
    },

    created ()
    {
        this.progression = this.progress
    },

    render () 
    {
        return (
            <div class='loading-bar'>
                <div class='background' />
                <div class='foreground' ref='foreground' />
                <div class='text'>{ this.text }</div>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            progression: '0'
        }
    },

    watch:
    {
        progress ()
        {
            this.progression = this.progress
        },

        progression ()
        {
            this.$refs.foreground.style.width = Number.parseFloat(this.progression) * 100 + '%'
            
            if (this.particles)
            {
                EventsUtils.setDelayedInterval(() =>
                {
                    const foreground = this.$refs.foreground
                    if (!foreground) return

                    const rect = foreground.getBoundingClientRect()
                    ParticleUtils.createParticle({x: rect.right, y: rect.y, zIndex: 10, size: [5, 10], color: 'white'})
                }, 50, 0, 500)
            }
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.loading-bar
{
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: -webkit-fill-available;
    height: 5px;
    border-radius: 100px;

    > .background
    {
        position: absolute;
        left: 0;
        top: 0;
        .WidthHeight(100%);
        background-color: var(--theme-search-bar-gray-background);
        border-radius: inherit;
    }

    > .foreground
    {
        position: absolute;
        left: 0;
        top: 0;
        width: 50%;
        max-width: 100%;
        height: 100%;
        background-color: var(--theme-content-background-color);
        border-radius: inherit;
        transition: width 0.5s ease-in-out
    }

    > .text
    {
        position: absolute;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/LoadingBar.vue